(ns ui.editors.card.fees.view
  (:require
   [re-frame.core :as rf]
   [ui.editors.card.fees.sub :as sub]
   [ui.editors.card.fees.event :as event]
   [ui.editors.card.shared.table-editor :as table-editor]
   [ui.editors.card.shared.entity-peek-editor :as entity-peek-editor]))

(defn table-settings
  []
  (let [selected-columns @(rf/subscribe [::sub/selected-columns])
        table-sort-by-field @(rf/subscribe [::sub/table-sort-by-field])
        sort-direction @(rf/subscribe [::sub/sort-direction])
        group-by-field @(rf/subscribe [::sub/group-by-field])
        available-column-options @(rf/subscribe [::sub/table-available-column-options])
        group-by-field-options @(rf/subscribe [::sub/table-group-by-field-options])]
    [table-editor/view
     {:selected-columns selected-columns
      :available-column-options available-column-options
      :group-by-field group-by-field
      :group-by-field-options group-by-field-options
      :sort-by-field-options selected-columns
      :sort-by-field table-sort-by-field
      :sort-direction sort-direction
      :add-column (fn [field]
                    (rf/dispatch [::event/add-table-column field]))
      :remove-column (fn [field]
                       (rf/dispatch [::event/remove-table-column field]))
      :reorder-columns (fn [start-idx end-idx]
                         (rf/dispatch-sync [::event/reorder-table-columns start-idx end-idx]))
      :set-sort-by-field (fn [field]
                           (rf/dispatch [::event/set-table-sort-by-field field]))
      :set-sort-direction (fn [direction]
                            (rf/dispatch [::event/set-table-sort-direction direction]))
      :set-group-by-field (fn [field]
                            (rf/dispatch [::event/set-table-group-by-field field]))}]))

(defn entity-peek-settings
  []
  (let [visible-fields-strategy @(rf/subscribe [::sub/entity-peek-visible-fields-strategy])
        visible-fields @(rf/subscribe [::sub/entity-peek-visible-fields])
        available-options @(rf/subscribe [::sub/entity-peek-available-visible-field-options])]
    [entity-peek-editor/view
     {:visible-fields-strategy visible-fields-strategy
      :visible-fields visible-fields
      :available-options available-options
      :add-field (fn [field]
                   (rf/dispatch [::event/add-entity-peek-visible-field field]))
      :remove-field (fn [field]
                      (rf/dispatch [::event/remove-entity-peek-visible-field field]))
      :reorder-fields (fn [start-idx end-idx]
                        (rf/dispatch-sync [::event/reorder-entity-peek-visible-fields start-idx end-idx]))
      :set-visible-fields-strategy (fn [value]
                                     (rf/dispatch [::event/set-entity-peek-visible-fields-strategy value]))}]))

(defn view
  []
  [:div
   {:class "flex flex-col gap-4"}
   [:div
    {:class "flex gap-4"}
    [:div
     {:class "w-1/2"}
     [table-settings]]
    [:div
     {:class "w-1/2"}
     [entity-peek-settings]]]])
